const EXPECTED_API_ERROR_STATUSES = new Set([400, 422, 427]);

const getStatusCode = (error: unknown): number | undefined => {
  if (!error || typeof error !== 'object' || !('statusCode' in error)) {
    return undefined;
  }

  const { statusCode } = error as { statusCode?: unknown };
  return typeof statusCode === 'number' ? statusCode : undefined;
};

export const isExpectedApiError = (error: unknown): boolean => {
  const statusCode = getStatusCode(error);
  return (
    statusCode !== undefined && EXPECTED_API_ERROR_STATUSES.has(statusCode)
  );
};
